<template>
 <!-- Site footer -->
 <div id="footer">
  <img
   id="logo-footer"
   src="../assets/logo.png"
   alt="Nova Aliança El Shaday Logo"
  />
  <footer class="footer">
   <div class="container">
    <div class="row">
     <div class="col-sm-12 col-md-6">
      <h6>Sobre Nós</h6>
      <p class="text-justify">
       Somos a Igreja Evangélica Nova Aliança EL SHADAY, lugar de amar a Deus e
       amar pessoas, gostaríamos de dar-lhe as boas vindas. Faça parte da nossa
       família. Acompanhe todas as nossas programações nas redes sociais. Venha
       nos visitar, será uma alegria lhe receber.
      </p>
     </div>

     <div class="col-xs-12 col-sm-6 col-md-3">
      <h6>Conecte-se</h6>
      <ul class="footer-links">
       <li v-if="whatsappPastoral"><a :href="whatsappLink(whatsappPastoral, 'Olá, graça e paz! Quero viver uma nova vida em Jesus e preciso de ajuda')" target="_blank">Preciso de Jesus</a></li>
       <li v-if="whatsappPastoral">
        <a :href="whatsappLink(whatsappPastoral, 'Olá, graça e paz! Estou procurando uma célula')" target="_blank">Encontre uma Célula</a>
       </li>
       <li v-if="whatsappVolunteer">
        <a :href="whatsappLink(whatsappVolunteer, 'Olá, graça e paz! Tenho interesse em ser um voluntário na El Shaday')" target="_blank">Seja um Voluntário</a>
       </li>
       <li>
         <a :href="locationLink" target="_blank">Localização</a>
       </li>
      </ul>
     </div>
     <div class="col-xs-12 col-sm-6 col-md-3">
      <h6>Contatos</h6>
      <ul class="footer-links">
       <li v-if="email">
        <a :href="`mailto:${email}`">{{ email }}</a>
       </li>
      </ul>
     </div>
    </div>
    <hr />
   </div>
   <div class="container">
    <div class="copyright-content">
     <div>
      <p class="copyright-text">
       Nova Aliança El Shaday &copy; {{ new Date().getUTCFullYear() }} Todos os
       Direitos Reservados.
      </p>
     </div>

     <div class="developer-credit">
        <span class="developer-text">Desenvolvido por</span>
        <a
          href="https://juliodevelop.online"
          target="_blank"
          rel="noopener noreferrer"
          class="developer-link"
        >
          <img src="/juliodevelop-logo.png" alt="JulioDevelop" class="developer-logo" />
        </a>
     </div>

     <div>
      <ul class="social-icons">
       <li>
        <a class="instagram" target="_blank" :href="instagram"
         ><i class="fa fa-instagram"></i
        ></a>
       </li>
       <li>
        <a class="youtube" target="_blank" :href="youtube"
         ><i class="fa fa-youtube"></i
        ></a>
       </li>
      </ul>
     </div>
    </div>
   </div>
  </footer>
 </div>
</template>

<script>
import { getLocationLink } from "@/utils/location.js";

export default {
 name: "FooterVue",
 props: {
  latitude: Number,
  longitude: Number,
  churchInfo: {
    type: Object,
    default: () => ({})
  },
 },
 data() {
  return {
   youtube: "https://www.youtube.com/@novaaliancaelshaday7179",
   instagram: "https://www.instagram.com/novaaliancaelshaday",
  };
 },
 computed: {
    whatsappPastoral() {
      return this.churchInfo.whatsapp_pastoral || ''
    },
    whatsappVolunteer() {
      return this.churchInfo.whatsapp_volunteer || ''
    },
    email() {
      return this.churchInfo.email || ''
    },
    locationLink() {
      return getLocationLink(this.latitude, this.longitude)
    }
  },
 methods: {
    whatsappLink(number, message) {
      return `https://wa.me/${number}?text=${encodeURIComponent(message)}`
    }
  }
};
</script>

<style>
#footer {
 background-color: #fff;
}
#logo-footer {
   margin: 50px auto 0 auto;
   opacity: 0.5;
   max-width: 254px;
   height: auto;
}
.footer {
 padding: 45px 0 20px;
 font-size: 15px;
 line-height: 24px;
 color: #737373;
 max-width: 1080px;
 margin: 0 auto;
}
.footer hr {
 opacity: 0.5;
}
.footer hr.small {
 margin: 20px 0;
}
.footer h6 {
 color: #555;
 font-size: 16px;
 text-transform: uppercase;
 margin-top: 5px;
 letter-spacing: 2px;
}
.footer a {
 color: #737373;
}
.footer a:hover {
 color: #3366cc;
 text-decoration: none;
}
.footer-links {
 padding-left: 0;
 list-style: none;
}
.footer-links li {
 display: block;
}
.footer-links a {
 color: #737373;
}
.footer-links a:active,
.footer-links a:focus,
.footer-links a:hover {
 color: #3366cc;
 text-decoration: none;
}
.footer-links.inline li {
 display: inline-block;
}
.footer .copyright-content {
   display: flex;
   align-items: center;
   justify-content: space-around;
}
.footer .social-icons {
 text-align: left;
}
.footer .social-icons a {
 width: 40px;
 height: 40px;
 line-height: 40px;
 margin-left: 6px;
 margin-right: 0;
 border-radius: 100%;
 background-color: #ccc;
}
.copyright-text {
 margin: 0;
}
@media (max-width: 991px) {
 .footer [class^="col-"] {
  margin-bottom: 30px;
 }
 .footer .copyright-content {
   flex-direction: column-reverse;
   gap: 30px;
 }
}
@media (max-width: 767px) {
 .footer {
  padding-bottom: 0;
 }
 .footer .copyright-text,
 .footer .social-icons {
  text-align: center;
 }
}
.social-icons {
 padding-left: 0;
 margin-bottom: 0;
 list-style: none;
}
.social-icons li {
 display: inline-block;
 margin-bottom: 4px;
}
.social-icons li.title {
 margin-right: 15px;
 text-transform: uppercase;
 color: #96a2b2;
 font-weight: 700;
 font-size: 13px;
}
.social-icons a {
 background-color: #eceeef;
 color: #818a91;
 font-size: 16px;
 display: inline-block;
 line-height: 44px;
 width: 44px;
 height: 44px;
 text-align: center;
 margin-right: 8px;
 border-radius: 100%;
 -webkit-transition: all 0.2s linear;
 -o-transition: all 0.2s linear;
 transition: all 0.2s linear;
}
.social-icons a:active,
.social-icons a:focus,
.social-icons a:hover {
 color: #fff;
 background-color: #29aafe;
}
.social-icons.size-sm a {
 line-height: 34px;
 height: 34px;
 width: 34px;
 font-size: 14px;
}
.social-icons a.facebook:hover {
 background-color: #3b5998;
}
.social-icons a.instagram:hover {
 background-color: #d011de;
}
.social-icons a.youtube:hover {
 background-color: #eb130c;
}
@media (max-width: 767px) {
 .social-icons li.title {
  display: block;
  margin-right: 0;
  font-weight: 600;
 }
 .footer {
  padding: 20px;
 }
}
@media (max-width: 376px) {
 .footer {
  padding: 20px;
 }
}

/* Developer Credit */
.developer-credit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.developer-text {
  font-size: 12px;
  color: rgba(115, 115, 115, 0.6);
}
.developer-link {
  display: flex;
  align-items: center;
  transition: opacity 0.2s ease;
}
.developer-link:hover {
  opacity: 0.7;
}
.developer-logo {
  width: 20px;
  height: 20px;
}
</style>
